React = require 'react'
t = require('views/internal/recup-with-helpers')('org_account')

module.exports = class extends React.Component
  render: t.renderable ->
    { onClick, member } = @props

    t.div ->
      t.ul '.pop-over-list', ->
        member.enterpriseList.forEach (enterprise) ->
          t.li =>
            t.a { href: "#", title: enterprise.get('displayName'), onClick: -> onClick(enterprise) }, ->
              t.div '.u-clearfix', ->
                t.span ->
                  t.text enterprise.get('displayName')



// WEBPACK FOOTER //
// ./app/scripts/views/organization/add-to-enterprise-popover-component.coffee